import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, locationAddedAction } from '../../reducers/actions';
import { LocationService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_LOCATION),
    switchMap(action =>
      LocationService.create(action.location, store).pipe(
        map(location => locationAddedAction(location)),
        catchError(retryAuthentication(action$, 'epics/locations/locationAdd'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/locations/locationAdd.js